import fotoHome1 from '../../assets/images/fotoHome1.png';
import fotoHome2 from '../../assets/images/fotoHome2.png';
import fotoHome3 from '../../assets/images/fotoHome3.png';


export const homeData = [
    {
        title: 'Más de 25 años fabricando y calibrando equipos para control de calidad.',
        image: fotoHome1,
        button: 'Conocenos',
        id: '/conocenos'
    },
    {
        title: 'Fabricación nacional y servicio postventa garantizado.',
        image: fotoHome2,
        button: 'Servicio Técnico',
        id: '/service'
    },
    {
        title: 'Garantía local, entrega rápida y servicio técnico directo del fabricante',
        image: fotoHome3,
        button: 'Clientes',
        id: '#clients'
    },
]